var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinnBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_760_4",
    "data-name": "Component 760 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    transform: "translate(-0.001)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360",
    transform: "translate(-852.169 -953.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    d: "M10.864,18.8h0a2.118,2.118,0,0,1-1.514-.631L1.276,10.1A2.138,2.138,0,0,1,1.27,7.079l.612-.611a2.135,2.135,0,0,1,3.02,0l.211.211,6.138-3.7A2.16,2.16,0,0,1,14.777.635l4.038,4.038A2.161,2.161,0,0,1,16.463,8.2l-3.7,6.137.212.212a2.139,2.139,0,0,1,.012,3.014l-.616.616A2.126,2.126,0,0,1,10.864,18.8ZM3.389,7.346a.632.632,0,0,0-.449.185l-.609.608a.636.636,0,0,0,0,.9l8.077,8.077a.635.635,0,0,0,.9,0l.612-.612a.636.636,0,0,0-.007-.894l-.629-.629a.75.75,0,0,1-.112-.918l4.411-7.316A.75.75,0,0,1,16.754,6.6l.062.061.006.006a.66.66,0,1,0,.932-.933L13.716,1.7a.66.66,0,1,0-.934.932l.006.006.061.062A.75.75,0,0,1,12.7,3.863L5.384,8.272a.75.75,0,0,1-.917-.112L3.84,7.533A.63.63,0,0,0,3.389,7.346Z",
    transform: "translate(852.682 954.254)",
    fill: "#213960"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_634",
    "data-name": "Line 634",
    d: "M0,5.772a.748.748,0,0,1-.54-.229.75.75,0,0,1,.018-1.06l5.2-5.022a.75.75,0,0,1,1.061.018A.75.75,0,0,1,5.721.539L.521,5.562A.748.748,0,0,1,0,5.772Z",
    transform: "translate(853.37 967.992)",
    fill: "#213960"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_635",
    "data-name": "Line 635",
    d: "M6.7,7.447a.748.748,0,0,1-.53-.22L-.53.53A.75.75,0,0,1-.53-.53.75.75,0,0,1,.53-.53l6.7,6.7a.75.75,0,0,1-.53,1.28Z",
    transform: "translate(857.679 961.883)",
    fill: "#213960"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_636",
    "data-name": "Line 636",
    d: "M4.038,4.788a.748.748,0,0,1-.53-.22L-.53.53A.75.75,0,0,1-.53-.53.75.75,0,0,1,.53-.53L4.569,3.508a.75.75,0,0,1-.53,1.28Z",
    transform: "translate(864.935 957.411)",
    fill: "#213960"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnBlack);
export default __webpack_public_path__ + "static/media/pinn-black.926da831e0015fa93b2ae7f195f5b2a1.svg";
export { ForwardRef as ReactComponent };